import type { User } from "../types";

export function isAdminRole(role?: User["role"]): boolean {
	return role === "admin" || role === "system-admin";
}

export function isSystemAdminRole(role?: User["role"]): boolean {
	return role === "system-admin";
}
